import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import CountUp from "react-countup";
import { Button } from "@/components/ui/button";

interface LessonCompleteProps {
  title: string;
  xp: number;
  onBack: () => void;
}

const LessonComplete: React.FC<LessonCompleteProps> = ({
  title,
  xp,
  onBack,
}) => (
  <div className="flex flex-col items-center justify-center text-center space-y-6 py-12">
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
    >
      <CheckCircle2 className="text-correct" size={64} />
    </motion.div>
    <p className="text-sm text-muted-foreground">Lesson completed</p>
    <h2 className="text-2xl font-bold">{title}</h2>
    <p className="text-lg text-muted-foreground">
      You earned{" "}
      <span className="text-foreground font-semibold">
        <CountUp end={xp} duration={1.5} /> XP
      </span>
    </p>
    <p className="text-xs text-muted-foreground">
      Progress saved · You can continue anytime
    </p>
    <Button onClick={onBack}>Back to Course</Button>
  </div>
);

export default LessonComplete;
